import { Reveal } from "./Motion";
import { MessageCircleHeart } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function FinalCTA({ onTalk }) {
  const { t } = useLang();
  return (
    <section id="contact" className="py-16 md:py-24 relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0" aria-hidden="true" style={{ backgroundColor: "hsl(var(--accent))" }} />
      <div className="relative max-w-[1000px] mx-auto px-4 md:px-8 text-center">
        <Reveal>
          <div className="chip !bg-foreground/10 !text-foreground !border-foreground/20">{t("final.chip")}</div>
          <h2 className="mt-5 font-heading text-4xl md:text-6xl leading-[1.02] text-foreground">
            {t("final.title_1")} <span className="italic">{t("final.title_par_ou")}</span> ?
          </h2>
          <p className="mt-6 text-lg md:text-xl text-foreground/85 leading-relaxed max-w-2xl mx-auto">
            {t("final.subtitle_1")}{" "}
            <span className="font-bold">{t("final.subtitle_bold")}</span>.
          </p>
          <div className="mt-8">
            <button
              onClick={onTalk}
              data-testid="final-talk-btn"
              className="pill-btn bg-foreground text-background hover:bg-primary hover:text-primary-foreground"
            >
              <MessageCircleHeart className="w-5 h-5" strokeWidth={2.5} />
              {t("final.cta")}
            </button>
          </div>
          <p className="mt-6 text-sm text-foreground/60">{t("final.note")}</p>
        </Reveal>
      </div>
    </section>
  );
}
